@if(firestoreService.getUserProfile().isAvailable) {
    @if (loading) {
    <div class="p-5 my-2 flex w-full justify-center">
        <p-progress-spinner ariaLabel="loading" strokeWidth="4" [style]="{ width: '50px', height: '50px' }" />
    </div>
    } @else {
        @if (availableBatches$ | async; as batches) {
        @for (batch of batches; track batch.batchId) {
        <div class="p-5 my-2 border rounded-xl border-0 bg-white">
            <div class="flex flex-row justify-content-between">
                <div class="flex-1">
                    <div class="text-xl font-bold capitalize text-green-600">${{batch.estimatedShopperPay.toFixed(2)}}</div>
                    <div class="font-light text-xs capitalize">Est. Earnings</div>
                </div>
                <div class="flex gap-2">
                    <p-button label="View Details" severity="secondary" [outlined]="true"
                        [style]="{'border-color': '#4D7935', color: '#4D7935'}" (click)="viewBatchDetails(batch)" />
                </div>
            </div>
            <div class="flex flex-row justify-content-between pt-4 gap-3">
                <div class="flex-1">
                    <div class="flex items-center justify-start">
                        <i class="pi pi-building text-gray-600 text-lg"></i>
                    </div>
                    <div class="text-sm font-light capitalize text-left pt-1">{{batch.stores.length || 0}} stores</div>
                </div>
                <div class="flex-1">
                    <div class="flex items-center justify-start">
                        <i class="pi pi-shopping-bag text-gray-600 text-lg"></i>
                    </div>
                    <div class="text-sm font-light capitalize text-left pt-1">{{batch.orders.length}} orders</div>
                </div>
                <div class="flex-1">
                    <div class="flex items-center justify-start">
                        <i class="pi pi-box text-gray-600 text-lg"></i>
                    </div>
                    <div class="text-sm font-light capitalize text-left pt-1">{{batch.totalItems}} items</div>
                </div>
            </div>
            <div class="flex flex-row justify-content-between pt-4 gap-3">
                <div class="flex-1">
                    <div class="flex items-center justify-start">
                        <i class="pi pi-directions text-gray-600 text-lg"></i>
                    </div>
                    <div class="text-sm font-light text-left pt-1">{{batch.estimatedTravelDistanceInMiles.toFixed(0)}} mi</div>
                </div>
                <div class="flex-1">
                    <div class="flex items-center justify-start">
                        <i class="pi pi-car text-gray-600 text-lg"></i>
                    </div>
                    <div class="text-sm font-light text-left pt-1">{{batch.estimatedTravelDistanceInMiles.toFixed(0)}} min</div>
                </div>
                <div class="flex-1">
                    <div class="flex items-center justify-start">
                        <i class="pi pi-shopping-cart text-gray-600 text-lg"></i>
                    </div>
                    <div class="text-sm font-light text-left pt-1">{{batch.estimatedShoppingTime.toFixed(0)}} min</div>
                </div>
            </div>
        </div>
            } @empty {
                <div class="p-4 pt-4">
                    <p-message severity="secondary">No available batches right now. Keep checking this space for new batches.</p-message>
                </div>
            }
        }
        }
        } @else {
        <div class="flex flex-col items-center justify-center h-full p-8">
            <p-message severity="warn"
                [text]="'Please turn on your availability to view available batches and accept them.'"></p-message>
    </div>
}
